import CountryPageRenderer from '../components/CountryPageRenderer';
import southKoreaData from '../data/country-pages/south-korea';

export default function SouthKoreaCountryPage() {
  return <CountryPageRenderer data={southKoreaData} />;
}
